import { useMemo } from 'react';

function toBlobUrl(data: string): string {
    function toBytes(base64: string): Uint8Array {
        // Decode the base64 string to a binary ArrayBuffer
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }
    // Create a Blob from the ArrayBuffer
    const pdfBlob = new Blob([toBytes(data)], { type: 'application/pdf' });

    // Create an object URL for the Blob
    return URL.createObjectURL(pdfBlob);
}

type PDFViewerProps = {
    pdf: string;
    name: string;
};

function PDFViewer({ pdf, name }: PDFViewerProps): JSX.Element {
    const url = useMemo(() => {
        if (pdf.startsWith('http')) {
            return pdf;
        } else {
            try {
                return toBlobUrl(pdf);
            } catch (error) {
                console.log(error);
                return null;
            }
        }
    }, [pdf]);

    return url === null ? <> </> : <iframe src={url} className="w-full h-full absolute" title={name}></iframe>;
}

export default PDFViewer;
